import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiErrorHandler } from "../../../errors/api-error-handler";
import {
  TaxonomyInitialStateType,
  TaxonomyType,
} from "../../../models/taxonomy-model";
import NewsArticlesRightSideTaxonomyService from "../../../services/right-side/news-articles-right-side-taxonomy.service";

const initialState: TaxonomyInitialStateType = {
  data: [],
  loading: false,
  error: undefined,
};

export const retrieveNewsArticlesRightSideTaxonomy = createAsyncThunk(
  "NewsArticlesRightSideTaxonomy/retrieve",
  async (eventPath: string) => {
    const response = await NewsArticlesRightSideTaxonomyService.getNewsArticlesRightSideTaxonomyService(eventPath)
    return [...response.data.result];
  }
);

const NewsArticlesRightSideTaxonomySlice = createSlice({
  name: "NewsArticlesRightSideTaxonomy",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(retrieveNewsArticlesRightSideTaxonomy.pending, (state) => {
        state.loading = true;
      })
      .addCase(retrieveNewsArticlesRightSideTaxonomy.fulfilled, (state, action) => {
        if (action.payload) {
          state.loading = false;
          state.data = action.payload as TaxonomyType[];
        }
      })
      .addCase(retrieveNewsArticlesRightSideTaxonomy.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = apiErrorHandler(Number(payload));
      });
  },
});

export const selectAllEntities = (state: { entities: any }) => state.entities;
export default NewsArticlesRightSideTaxonomySlice.reducer;
